import { IOutFeaturedDealDTO } from "@app/components/deal-cards/new-deal-card/deal-card.interface";
import { WordPressPostModule } from "@app/api/modules/wordpress-module/wordpress-module";
import { FeaturedDealsModule } from "@app/api/modules/featured-deals/featured-deals.module";
import { FeaturedDealsSearchModule } from "@app/api/modules/featured-deals-search/featured-deals-search.module";
import { SearchResultsModule } from "@app/api/modules/search-results/search-results.module";
import { getModulesToShow } from "@app/api/modules/search-results/get-modules-to-show";

/**
 * The deals the search page renders on the server. `getModulesToShow` is the component's own rule
 * for whether the deals section is on the page at all. When it is, the found deals are cut to the
 * collapsed limit, as `CardResults` does: the rest only exists after "show more". With nothing found
 * the section shows the popular-deals fallback instead.
 */
const getSearchResultDeals = (module: SearchResultsModule): IOutFeaturedDealDTO[] => {
  const { modules, searchResults, defaults, isCollapsible, collapsedLimits } = module;

  if (!getModulesToShow(modules, searchResults, true).showDeals) return [];

  const foundDeals = searchResults?.deals?.data || [];

  if (foundDeals.length === 0) return defaults?.deals || [];

  return isCollapsible?.deals ? foundDeals.slice(0, collapsedLimits.deals) : foundDeals;
};

/**
 * Every deal tile the mapped modules render on the server, from any section of the page. A new
 * module that shows deal cards must be added here, or its deals stay out of the page's `@graph`.
 */
export const getModuleDeals = (moduleList?: WordPressPostModule[]): IOutFeaturedDealDTO[] =>
  (moduleList || []).flatMap((module) => {
    switch (module.name) {
      case "FeaturedDealsModule":
      case "FeaturedDealsSearchModule":
        return (module as FeaturedDealsModule | FeaturedDealsSearchModule).featuredDeals || [];
      case "SearchResultsModule":
        return getSearchResultDeals(module as SearchResultsModule);
      default:
        return [];
    }
  });
